

















































































import {
  ref,
  defineComponent,
  watchEffect,
  reactive,
} from "@vue/composition-api";
import { useModelWrapper } from "./../../service/base/modelWrapper";
import { WorkOrderForm } from "./../../service/interfaces/WorkOrderModel";
export default defineComponent({
  name: "workOrder",
  components: {},
  props: {
    btnLabel: {
      require: true,
      type: String,
    },
    btnIcon: {
      require: true,
      type: String,
    },
    editData: {
      require: false,
      type: Object,
      default: () => ({
        workWorderNumber: "",
        ServiceRequest: "",
        SubStatus: "",
      }),
    },
  },
  setup(props, { emit }) {
    const dialog = ref(false);
    const tabItems = ref(["Summary", "Specification"]);
    const tab = ref();
    const formData = reactive<WorkOrderForm>({
      workWorderNumber: "",
      ServiceRequest: props.editData.ServiceRequest
        ? props.editData.ServiceRequest
        : "",
      SubStatus: props.editData.SubStatus ? props.editData.SubStatus : "",
    });
    return {
      dialog,
      tabItems,
      tab,
      formData,
    };
  },
});
